import { isDebugUIEnabled } from '../../config/debug';
import { usePhraseParticipants } from '../../hooks/usePhraseParticipants';
import useWSSlideData from '../../hooks/useWSSlideData';
import { WhWordsSection } from '../PhraseComponents';
import PhraseCompletionSection from '../PhraseComponents/PhraseCompletionSection';
import { PhraseDivider } from '../PhraseComponents/PhraseDivider';
import RoundProgress from '../PhraseComponents/RoundProgress';
import NextIn from './NextIn';
import './SlidesCommon.css';

export default function ContentFraseCompletar() {
  // const { activeMessage } = useWSMessageMessages();
  const { slideData } = useWSSlideData();

  // Hooks customizados para separar responsabilidades
  const { first, second } = usePhraseParticipants();


  // Valores mockados para debug
  const debugProgress = { current: 2, total: 25 };
  const progress = slideData?.progress || (isDebugUIEnabled ? debugProgress : null);

  return (
    <div className="slide-container" style={{ flexDirection: 'column', position: 'relative', height: '100%' }}>
      {/* Indicador de progresso do round */}
      {progress && (
        <RoundProgress
          current={progress.current}
          total={progress.total}
        />
      )}

      {/* Seção de cima: participante + frase centralizada */}
      <PhraseCompletionSection participant={first} />
      <PhraseDivider />
      {/* Seção de baixo: participante + wh words centralizadas */}
      <WhWordsSection participant={second} />
      <NextIn />
      {/* Feedback balloon */}
      {/* <div style={{ position: 'absolute', right: 32, bottom: 100, zIndex: 20 }}>
        <BalloonFeedback message={activeMessage?.content || ''} />
      </div> */}
    </div>
  );
}
